import React, { useEffect, useState, useContext } from "react";
import Body from "./Body";
import Sideber from "./Sidebar";
import style from "../style/Layout.module.scss";
import { useQuery } from "react-query";
import { NoticeDataContext } from "../contexts/NoticeDataContext";
import apiClient from "../libraries/ApiClient";

function Layout({ open, setOpen, setNoticeData, closeConnection }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { nData, setNData, refreshNData, setRefreshNData } =
    useContext(NoticeDataContext);

  const getNoticeData = async ({ queryKey }) => {
    const data = {
      Data: {},
    };
    const res = await apiClient.postAes("api/referral/Notice/Security", data);
    // console.log(res);

    return res?.data?.Data;
  };

  const { data: noticeData, refetch } = useQuery(
    ["getNoticeData"],
    getNoticeData,
    {
      refetchOnWindowFocus: false,
      onSuccess: (noticeData) => {
        localStorage.setItem("noticeData", JSON.stringify([noticeData]));
        // console.log(123);
      },
    }
  );
  // console.log(noticeData);
  useEffect(() => {
    if (refreshNData >= 0) {
      refetch();
    }

    setNoticeData(noticeData);
    setNData(noticeData);
    setRefreshNData(-1);
  }, [noticeData, refreshNData]);

  return (
    <div
      className={sidebarOpen ? `${style.sidebarActive}` : `${style.sidebar}`}
    >
      <Sideber sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <Body
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        setOpen={setOpen}
        open={open}
        noticeData={noticeData}
        closeConnection={closeConnection}
      />
    </div>
  );
}

export default Layout;
